module.exports = "td{\r\n    border: 1px solid #ccc\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/prospect/telecaller/telecaller-grid/telecaller-grid.component.css
// module id = ./src/app/prospect/telecaller/telecaller-grid/telecaller-grid.component.css
// module chunks = main